import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../app/core/services/auth.service';
import { IdleWatcherService } from '../app/services/idle-watcher.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        private authService: AuthService,
        private idleWatcher: IdleWatcherService
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const isStatusCheckCall = request.url.includes('users/show');

        // exclude the polling call — otherwise it alone would keep resetting
        // the idle timer every 5s regardless of real user activity
        if (!isStatusCheckCall) {
            this.idleWatcher.notifyActivity();
        }

        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401 || error.status === 403) {
                    if (isStatusCheckCall) {
                        // 401 from users/show = account disabled — force logout
                        this.authService.clearSession();
                        this.router.navigate(['/login']);
                    } else {
                        // 401/403 from other endpoints = unauthorized page access
                        // redirect to their allowed landing page
                        this.router.navigate(['/access-denied']);
                    }
                }
                return throwError(() => error);
            })
        );
    }
}
